var _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHomePageStar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 82,
    viewBox: "0 0 82 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41 44.62L66.625 37.925",
    stroke: "url(#paint0_linear_16_1117)",
    strokeOpacity: 0.6,
    strokeWidth: 30,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M72.7189 28.2756L52.3871 25.3208L43.2982 6.89478C43.05 6.39029 42.6416 5.98189 42.1371 5.73365C40.8719 5.10904 39.3344 5.62955 38.7017 6.89478L29.6129 25.3208L9.28104 28.2756C8.72049 28.3557 8.20799 28.62 7.81561 29.0204C7.34124 29.5079 7.07984 30.1639 7.08885 30.8441C7.09786 31.5243 7.37654 32.1731 7.86365 32.6479L22.574 46.9899L19.0986 67.2417C19.0171 67.7128 19.0692 68.1973 19.2491 68.6403C19.4289 69.0832 19.7293 69.467 20.1162 69.7479C20.503 70.0289 20.9608 70.1958 21.4377 70.2298C21.9146 70.2638 22.3915 70.1635 22.8142 69.9403L41 60.379L59.1857 69.9403C59.6822 70.2046 60.2588 70.2926 60.8113 70.1965C62.2047 69.9563 63.1416 68.635 62.9014 67.2417L59.426 46.9899L74.1363 32.6479C74.5367 32.2555 74.801 31.743 74.881 31.1825C75.0973 29.7811 74.1203 28.4838 72.7189 28.2756ZM53.2359 44.9719L56.1267 61.8124L41 53.8686L25.8732 61.8204L28.764 44.9799L16.5281 33.0483L33.4406 30.5899L41 15.271L48.5594 30.5899L65.4719 33.0483L53.2359 44.9719Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_16_1117",
    x1: 53.8125,
    y1: 37.925,
    x2: 77.4058,
    y2: 43.6455,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD392"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDB664",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomePageStar);
export default __webpack_public_path__ + "static/media/homePageStar.3a892feb1483d511b353e6211013c5f8.svg";
export { ForwardRef as ReactComponent };